import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController,ModalController, Modal } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Items } from '../../providers/items';

/**
 * Generated class for the AddNotePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-add-battery',
  templateUrl: 'add-battery.html',
})
export class AddBatteryPage {
  clientId: string = this.navParams.get('clientId');
  battery: { name: string, description: string} = {
    name: 'New Battery',
    description: '',
  };

  submitClient: boolean = false;
  isReadyToSend: boolean;
  batteries: any[] ;
  isEditBattery: boolean = false;

  form: FormGroup;

  constructor(public navCtrl: NavController, public viewCtrl: ViewController, formBuilder: FormBuilder, public navParams: NavParams, public modalCtrl: ModalController,public items: Items) {
    
    this.form = formBuilder.group({
      name: [this.battery.name, Validators.required],
      description: [this.battery.description, Validators.required]
    });

    if (this.navParams.data.battery) {
      this.isEditBattery = true;
      this.form.setValue({
        name: this.navParams.data.battery.name, 
        description: this.navParams.data.battery.description,
      });
      this.isReadyToSend = true;
    }

    // Watch the form for changes, and
    this.form.valueChanges.subscribe((v) => {
      this.isReadyToSend = this.form.valid;
    });
  }

  ionViewDidLoad() {
    //console.log('inside ionViewDidLoad AddNotePage');
    
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  selectAssessment(){
    if (!this.form.valid) { return; }
    if(this.isEditBattery){
      var assessments = this.navParams.data.battery.assessments,
      modal = this.modalCtrl.create('SelectAssessmentPage', { battery: "editBattery",batteryAssessments: assessments });
      modal.onDidDismiss(item => {
        if (item) {
          let assessmentIds = [];
            for (let assessment of item) {
              assessmentIds.push(assessment.id);
            }
             this.viewCtrl.dismiss({form: this.form.value, assessments: assessmentIds, dismiss:'done'});
            
        }
      })
    }else{
       modal = this.modalCtrl.create('SelectAssessmentPage', { battery: "battery" } );
      modal.onDidDismiss(item => {
      if (item) {
        let assessmentIds = [];
          for (let assessment of item) {
            assessmentIds.push(assessment.id);
          }
          this.viewCtrl.dismiss({form: this.form.value, assessments: assessmentIds});
      }
    })
    }
    
    modal.present();
  }
  

  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    if (!this.form.valid) { return; }
    this.viewCtrl.dismiss({form: this.form.value, dismiss:'done'});
    // this.viewCtrl.dismiss(this.form.value);
  }

  deleteBattery(){
    if (!this.form.valid) { return; }
    this.viewCtrl.dismiss({form: null, dismiss:'delete'});
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-battery/add-battery.ts